
 let heatmapChartValues = {

    co2: {
        unit: "ppm",
        value_name: "Concentration",
        range: [{
            from: 0,
            to: 500,
            color: "#1DE4B2",
            name: "Good"
          }, {
            from: 500,
            to: 1000,
            color: "#F5DD87",
            name: "Satisfactory"

          }, {
            from: 1000,
            to: 4000,
            color: "#FF0000",
            name: "Poor"

          }, {
            from: 4000,
            color: "#AC0101",
            name: "Very bad"

          },
             ]
    },
    voc:{
        unit: 'μg/m3',
        value_name: "VOC ",
        range: [{
            from: 0,
            to: 299,
            color: "#1DE4B2",
            name: "Good"
          }, {
            from: 300,
            to: 499,
            color: "#F5DD87",
            name: "Satisfactory"

          }, {
            from: 500,
            to: 999,
            color: "#FF0000",
            name: "Poor"

          }, {
            from: 1000,
          //  to: 500,
            color: "#AC0101",
            name: "Very bad"

          },
        //   {
        //     from: 500,
        //     color: "#AC0101",
        //     name: "Very bad"
        //   },
          
        ]
    },
    aq_pm1:{
        unit: "μg/m³",
        value_name: "Concentration",
        range: [{
            from: 0,
            to: 10,
            color: "#42e6f5",
            name: "Good"
          }, {
            from: 10,
            to: 20,
            color: "#1cedb5",
            name: "Fair"

          }, {
            from: 20,
            to: 25,
            color: "#f0e641",
            name: "Moderate"

          }, {
            from: 25,
            to: 50,
            color: "#ff5050",
            name: "Poor"
          },
          {
            from: 50,
            to: 75,
            color: "#960032",
            name: "Very poor"
        },
        {
            from: 75,
            color: "#7d2181",
            name: "Extremely poor"

            },
        ]

    },
    aq_pm4:{
        unit:"μg/m³",
        value_name: "Concentration",
        range: [{
            from: 0,
            to: 20,
            color: "#0FF1FF",
            name: "Good"
          }, {
            from: 20,
            to: 40,
            color: "#1DE4B2",
            name: "Fair"
          }, {
            from: 40,
            to: 50,
            color: "#f0e641",
            name: "Moderate"
          }, {
            from: 50,
            to: 100,
            color: "#ff5050",
            name: "Poor"
          },
          {
            from: 100,
            to: 150,
            color: "#960032",
            name: "Very poor"
        },
        {
            from: 150,
            color: "#7d2181",
            name: "Extremely poor"

            },
          
        ]

    },
   
}





export const heatmapList=[
    {
        name:'CO2',
        endPoint:'aq_co2',
        slug: "co2"
    },
    {
        name:'VOC',
        endPoint:'aq_voc',
        slug: "voc"
    },
    {
        name:'Air quality (PM1)',
        endPoint:'aq_pm1',
        slug: "aq_pm1"
    },
    {
        name:'Air quality (PM2.5)',
        endPoint:'aq_pm2_5',
        slug: "aq_pm2_5"
    },
    {
        name:'Air quality (PM4)',
        endPoint:'aq_pm4',
        slug: "aq_pm4"
    },
    {
        name:'Air quality (PM10)',
        endPoint:'aq_pm10',
        slug: "aq_pm10"

    }

]

heatmapChartValues = {
    ...heatmapChartValues,
    aq_pm2_5:{...heatmapChartValues.aq_pm1},

    aq_pm10:{...heatmapChartValues.aq_pm4}
}

export {heatmapChartValues}